(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityBillingConfig', FacilityBillingConfig);

    FacilityBillingConfig.$inject = ['$resource'];

    function FacilityBillingConfig ($resource) {
        var resourceUrl =  'api/facility-billing-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFacility': {url: 'api/facility-billing-configs', method: 'GET', isArray: true}
        });
    }
})();
